<div
  class="sia-grid-footer"
  id="siaGridFooter"
  [siaTooltip]="view"
  position="top"
  tabindex="0"
  mat-raised-button
  [disable]="true"
>
  @if (actions && actions.length > 0) {
    @if (selectedAction) {
      <div class="sia-grid-footer__actions">
        <span class="material-symbols-outlined" (click)="selectedAction = null"
          >close</span
        >
        <span class="material-symbols-outlined" (click)="confirmCurrentAction()"
          >check</span
        >
      </div>
    }
    @if (!selectedAction) {
      <mat-form-field
        floatLabel="always"
        appearance="outline"
        class="sia-grid-footer__actions"
        [subscriptSizing]="'dynamic'"
      >
        <mat-label>{{ 'Azioni rapide' | siaTranslate }}</mat-label>
        <mat-select [(value)]="selectedAction">
          @for (action of actions; track action) {
            <mat-option [value]="action">
              {{ action.description | siaTranslate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  } @else {
    <div></div>
  }
  @if (gridViewMode != 'infinite') {
    <mat-paginator
      color="accent"
      class="sia-grid-footer__count"
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 15, 20, 50, 100, 200]"
      (page)="paginationChanged($event)"
      [hidePageSize]="gridViewMode != 'page'"
    ></mat-paginator>
  }
</div>
